import { ReactNode } from "react";
import "shepherd.js/dist/css/shepherd.css";
import "@/styles/shepherd.css";

interface AppTourStylesProviderProps {
  children: ReactNode;
}

/**
 * AppTourStylesProvider Component
 *
 * Imports Shepherd.js CSS and custom tour styles.
 * This component does not provide React context - it only handles CSS imports.
 *
 * @param children - Child components to wrap
 */
export function AppTourStylesProvider({ children }: AppTourStylesProviderProps) {
  return <>{children}</>;
}
